import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HostDevice } from '../../../../core/models/globals';
import { GpuInstanceI } from '../../../../core/models/nodeGpu';
import { NodeService } from '../../../../core/services/node.service';

enum InstanceMessageI {
  Loading = "Loading instances...",
  Empty = "No instances found yet.",
  Error = "Failed to load instances."
}

@Component({
  selector: 'app-attach-v-gpu',
  templateUrl: './attach-v-gpu.component.html',
  styleUrls: ['./attach-v-gpu.component.scss']
})
export class AttachVGPUComponent implements OnInit {

  constructor(
    public dialog: MatDialogRef<AttachVGPUComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
        hostNodeId: string,
        depName: string,
        activeNodeName: string,
        vmId: string,
        action: string,
        titleMessage: string
    },
    public _nodeService: NodeService,
    private snackBar: MatSnackBar,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  gpuInstanceList: GpuInstanceI[] = [];
  noInstanceMessage: string = InstanceMessageI.Loading;
  attachvGPUForm: UntypedFormGroup;
  isSelectAll: boolean = false;
  disableSubmit: boolean = false;
  hostDevicesToAttach: HostDevice[] = [];
  hostDevicesToDetach: HostDevice[] = [];
  titleMessage: string = this.data.titleMessage;
  action: string = this.data.action;

  ngOnInit(): void {
    this.getInstanceList();
    this.attachvGPUForm = new UntypedFormGroup({
      vGpuInstance: new UntypedFormControl(),
      hostDeviceIdToAttach: new UntypedFormControl(),
      hostDeviceIdToDetach: new UntypedFormControl()
    })
  }

  onClose() {
    this.dialog.close(false)
  }

  onSubmit(form) {
     this.spinner.show("spinner");
    let instanceName = form.value.vGpuInstance
    let hostDeviceId = "none";
    if (this.action?.toLowerCase() == "attach") {
      hostDeviceId = form.value?.hostDeviceIdToAttach;
    }
    else if (this.action?.toLowerCase() == "detach") {
      hostDeviceId = form.value?.hostDeviceIdToDetach;
    }
    if (this.data.action.toLowerCase() == "attach") {
      this._nodeService.attachvGPU(this.data.depName, this.data.activeNodeName, instanceName, this.data.vmId, hostDeviceId)
        .subscribe({
          next: (data: any) => {
            this.spinner.hide("spinner");
            this.snackBar.open(data?.successMessage, "Ok", { duration: 5000 });
            this.dialog.close()
            this.refreshComponent();
          },
          error: (err) => {
            this.spinner.hide("spinner");
            this.snackBar.open(err?.error?.successMessage, "Ok", { duration: 5000 })
            this.dialog.close()
          }
        })
    }
    else if (this.data.action.toLowerCase() == "detach") {
      this._nodeService.detachvGPU(
        this.data.activeNodeName,
        this.data.hostNodeId,
        this.data.depName,
        this.data.vmId,
        hostDeviceId
      ).subscribe({
        next: (data: any) => {
          this.spinner.hide("spinner");
          this.snackBar.open(data?.successMessage, "Ok", { duration: 5000 })
          this.dialog.close()
          this.refreshComponent();
        },
        error: (err) => {
          this.spinner.hide("spinner");
          this.snackBar.open(err?.error?.successMessage, "Ok", { duration: 5000 })
          this.dialog.close()
        }
      })
    }
  }

  getInstanceList() {
    this.spinner.show("spinner");
    if (!this.data.hostNodeId || this.data.hostNodeId == null) {
      this.snackBar.open(`Can not perform action since no host found for ${this.data.activeNodeName}.`, "Ok", { duration: 5000 })
      this.dialog.close();
      return
    }
    this._nodeService.getGpuSlaveListForMasterToAttach(this.data.depName, this.data.activeNodeName, this.data.hostNodeId, this.action)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide("spinner");
          if (!data) {
            this.noInstanceMessage = InstanceMessageI.Empty;
            this.snackBar.open(InstanceMessageI.Empty, "Ok", { duration: 5000 });
            this.dialog.close();
            //this.disableSubmit = true;
          }
          if (data?.gpuInfoes) {
            this.gpuInstanceList = JSON.parse(JSON.stringify(data?.gpuInfoes))
          }

          if (data?.hostDevicesForVmToAttach) {
            this.hostDevicesToAttach = JSON.parse(JSON.stringify(data?.hostDevicesForVmToAttach));
          }
          else {
            this.snackBar.open(`Unable to find vGPU to attach.`, "Ok", { duration: 5000 })
          }

          if (data?.hostDevicesForVmToDetach) {
            this.hostDevicesToDetach = JSON.parse(JSON.stringify(data?.hostDevicesForVmToDetach));
          }
        },
        error: (err) => {
          this.spinner.hide("spinner");
          this.noInstanceMessage = InstanceMessageI.Error;
          this.snackBar.open(InstanceMessageI.Error, "Ok", { duration: 5000 });
          this.dialog.close();
          //this.disableSubmit = true;
        }
      })
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
